'use client'

import { NextIntlClientProvider } from 'next-intl'
import type { ReactNode } from 'react'

type RouteIntlMessagesProviderProps = {
  locale: string
  messages: Record<string, unknown>
  children: ReactNode
}

export function RouteIntlMessagesProvider({
  locale,
  messages,
  children
}: RouteIntlMessagesProviderProps) {
  return (
    <NextIntlClientProvider locale={locale} messages={messages}>
      {children}
    </NextIntlClientProvider>
  )
}
